/* eslint-disable */
/*
  R24 · Kontrolliertes Nachladen von Ergebnisseiten („Mehr laden").

  WARUM ES DAS GIBT (Audit M-09, 21.09.2026)
  Die Suchseite lud beim Oeffnen OHNE Scrollen alle Folgeseiten — gemessen im
  Preview: 27 Seiten, 982 Karten, rund 7 Sekunden, vier Anfragen gleichzeitig.
  Ursache war kein Sentinel, sondern ein bedingungsloser Aufruf
  `colLoadAllFast()` beim Start und nach jedem Filter-/Sortierwechsel; bei einem
  Fehler sprang eine rekursive Kette `colLoadAll(guard+1)` ein, und jeder
  fehlgeschlagene Abschnittsabruf zog sofort einen zweiten Vollseitenabruf nach.
  Unter Shopifys 429-Drosselung verdoppelte das die Last genau dann, wenn der
  Server um weniger bat.

  Gemeinsam genutzt von sections/r24-search-2026.liquid (M-09) und
  sections/r24-collection-2026.liquid (M-09B) — EINE Engine, keine Kopie.

  REGELN, die dieser Baustein garantiert
    1  hoechstens EINE Anfrage gleichzeitig
    2  jede Seite hoechstens einmal, in lueckenloser Folge (n → n+1)
    3  automatisch hoechstens `autoMax` Seiten (Standard 2: Seite 2 und 3),
       ausgeloest nur durch Sichtbarkeit NACH eigenem Scrollen — danach nur
       noch per Knopf, genau EIN Batch je Klick
    4  kein Wiederholen von selbst: nach 429/5xx/Netzfehler ist Schluss mit
       Automatik; erneut versucht wird nur auf Klick
    5  Filter-/Sortier-/Zurueck-Wechsel: laufende Anfrage wird abgebrochen
       (AbortController), jede spaete Antwort wird verworfen (Generation)

  AUFBAU
    R24Pager.core(opts)   reine Zustandsmaschine, KEIN DOM — in Node getestet
                          (scripts/search-pager.contract.test.mjs)
    R24Pager.view(state)  Zustand → Anzeige des Knopfs, ebenfalls rein
    R24Pager.mount(root)  duenner DOM-Adapter fuer die r24col-Leiste
                          [data-r24-morebar] / #r24col-grid
    R24Pager.fetchPage(url, sectionId, signal?, probe?)
                          holt EINE Seite als Document (siehe unten). Auch der
                          Filter-/Sortierwechsel beider Sections nutzt sie —
                          EINE Abrufregel fuer alles.
                          probe: CSS-Selektor, an dem eine VOLLSTAENDIGE
                          Section-Antwort erkannt wird. Standard
                          '#r24col-results' (Kategorie/Suche). Andere Raster
                          geben ihren eigenen an, z. B. die Serienseite (A8,
                          M-09C) ihr Serienraster — sonst wuerde dort jede
                          Seite ein zweites Mal als Vollseite geholt.
                          Rueckwaertskompatibel: ohne probe unveraendert.

  Einbindung: Die Section laedt diese Datei mit `defer` und reiht ihren Aufruf
  in window.R24PagerQ ein, bis sie da ist (wie r24-price-filter.js).
*/
(function (W) {
  'use strict';
  if (W.R24Pager) return;

  var AUTO_MAX = 2;

  /** Fehler in unserem Code sichtbar machen statt verschlucken — EINE Zeile je Vorfall. */
  function warn(what, e) {
    if (W.console && W.console.warn) W.console.warn('[R24Pager] ' + what + ':', e && e.message ? e.message : e);
  }

  /** Seitenzahl aus einer Adresse; ohne `page` ist es Seite 1. */
  function pageOf(url) {
    var m = /[?&]page=(\d+)/.exec(String(url || ''));
    return m ? parseInt(m[1], 10) : 1;
  }

  /* ------------------------------------------------------------------ Kern */

  /**
   * opts.next     Adresse der naechsten Seite oder null
   * opts.autoMax  wie viele Seiten automatisch nachgeladen werden duerfen
   * opts.load     function (url, signal) → Promise<{ count, next }>
   *               verwirft mit { status } bei HTTP-Fehler, { aborted } bei Abbruch
   * opts.apply    function (result, url) — nur fuer die AKTUELLE Generation
   * opts.onState  function (state, info) — 'idle' | 'loading' | 'error' | 'end' | 'stopped'
   */
  function core(opts) {
    var autoMax = typeof opts.autoMax === 'number' ? opts.autoMax : AUTO_MAX;
    var gen = 0, flight = null, next = null, lastPage = 0, autoLeft = autoMax, state = 'idle', seen = {};

    function setState(s, info) { state = s; if (opts.onState) opts.onState(s, info || {}); }

    function start(url) {
      next = url || null;
      lastPage = next ? pageOf(next) - 1 : 0;
      seen = {};
      autoLeft = autoMax;
      setState(next ? 'idle' : 'end');
    }

    function request(kind) {
      if (flight) return false;                                   // Regel 1
      if (state === 'stopped') return false;
      if (!next) { if (state !== 'end') setState('end'); return false; }
      if (kind === 'auto' && (autoLeft <= 0 || state === 'error')) return false;   // Regel 3/4
      var page = pageOf(next);
      if (seen[page] || page !== lastPage + 1) {                  // Regel 2
        next = null; setState('end', { anomaly: true }); return false;
      }
      if (kind === 'auto') autoLeft--;
      var url = next, myGen = gen;
      var ctl = typeof AbortController === 'function' ? new AbortController() : null;
      flight = { ctl: ctl, page: page };
      setState('loading', { kind: kind, page: page });
      var p;
      try { p = Promise.resolve(opts.load(url, ctl ? ctl.signal : undefined)); }
      catch (e) { p = Promise.reject(e); }
      p.then(function (res) {
        if (myGen !== gen) return;                                // Regel 5: veraltet
        flight = null;
        seen[page] = true;
        lastPage = page;
        var n = res && res.next ? res.next : null;
        /* Nur die unmittelbar folgende Seite ist gueltig — sonst Schluss statt
           Luecke oder Schleife. */
        if (n && pageOf(n) !== page + 1) n = null;
        next = n;
        /* Wirft das Anhaengen (Fehler in UNSEREM Code), blieb der Knopf fuer
           immer auf „Lädt …" und die Konsole zeigte nur eine namenlose
           Promise-Ablehnung. Jetzt: Fehlerzustand + Warnung mit Kontext. */
        try { if (opts.apply) opts.apply(res || { count: 0 }, url); }
        catch (e) {
          warn('Anhaengen von Seite ' + page, e);
          /* Stand zuruecksetzen: „erneut versuchen" laedt DIESE Seite noch einmal,
             statt sie zu ueberspringen (Review R2 — sonst fehlten ihre Artikel). */
          delete seen[page]; lastPage = page - 1; next = url;
          autoLeft = 0; setState('error', { kind: kind, page: page, status: 0 }); return;
        }
        setState(next ? 'idle' : 'end', { kind: kind, page: page, count: res && res.count || 0 });
      }, function (err) {
        if (myGen !== gen) return;                                // abgebrochen/veraltet
        flight = null;
        autoLeft = 0;                                             // Regel 4
        setState('error', { kind: kind, page: page, status: err && err.status || 0 });
      });
      return true;
    }

    /** Laufende Anfrage abbrechen, jede spaete Antwort verwerfen. */
    function cancel() {
      gen++;
      if (flight && flight.ctl) { try { flight.ctl.abort(); } catch (e) {} }
      flight = null;
    }

    start(opts.next);

    return {
      auto: function () { return request('auto'); },
      more: function () { return request('manual'); },
      /** Neue Ergebnisliste (Filter/Sortierung/Zurueck): wieder ab ihrer Seite 2. */
      reset: function (url) { cancel(); start(url); },
      /** Waehrend ein Wechsel laeuft: nichts laden, nichts anhaengen. */
      stop: function () { cancel(); setState('stopped'); },
      get state() { return state; },
      get inFlight() { return !!flight; },
      get autoLeft() { return autoLeft; },
      get lastPage() { return lastPage; },
      get next() { return next; }
    };
  }

  /* ------------------------------------------------- Anzeige (rein) */

  function view(state) {
    switch (state) {
      case 'loading': return { hidden: false, disabled: true,  busy: true,  text: 'Lädt …' };
      case 'error':   return { hidden: false, disabled: false, busy: false, text: 'Laden nicht möglich – erneut versuchen' };
      case 'end':     return { hidden: true,  disabled: true,  busy: false, text: '' };
      case 'stopped': return { hidden: false, disabled: true,  busy: false, text: 'Mehr laden' };
      default:        return { hidden: false, disabled: false, busy: false, text: 'Mehr laden' };
    }
  }

  /* --------------------------------------------------------- DOM-Adapter */

  function parseDoc(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function sectionUrl(url, sectionId) {
    try { var u = new URL(url, W.location.origin); u.searchParams.set('section_id', sectionId); return u.toString(); }
    catch (e) { return null; }
  }

  /**
   * Holt EINE Seite. Erst die Section-Rendering-API; nur wenn DIESE Antwort
   * erfolgreich war, aber keine Ergebnisliste (probe) enthielt, einmal die
   * Vollseite (nacheinander, nie parallel). Ein HTTP-Fehler (429/5xx) ist ein
   * Fehler — kein sofortiger zweiter Versuch; verworfen wird mit { status }.
   *   probe  optionaler Selektor der Ergebnisliste, Standard '#r24col-results'
   */
  function fetchPage(url, sectionId, signal, probe) {
    var o = { headers: { 'X-Requested-With': 'fetch' }, signal: signal };
    function get(u) {
      return fetch(u, o).then(function (r) {
        if (!r.ok) { var e = new Error('http ' + r.status); e.status = r.status; throw e; }
        return r.text();
      }).then(parseDoc);
    }
    var su = sectionUrl(url, sectionId);
    var first = su ? get(su) : get(url);
    return first.then(function (doc) {
      if (doc.querySelector(probe || '#r24col-results') || !su) return doc;
      return get(url);
    });
  }

  /**
   * root: Section-Element. opts:
   *   sectionId, autoMax, rootMargin
   *   noun             — Mehrzahl fuer die Statusmeldung: Suche „Ergebnisse“
   *                      (Standard), Kategorie „Produkte“. Einzige Stelle, an
   *                      der sich die beiden Seiten unterscheiden.
   *   onAppend(cards)  — nach jedem Anhaengen (Herzen, Klammer, Reiter)
   * Rueckgabe: { more, stop, rebind, core }
   */
  function mount(root, opts) {
    opts = opts || {};
    var noun = opts.noun || 'Ergebnisse';
    var bar = null, grid = null, btn = null, statusEl = null, io = null, pager = null;
    var total = 0, shown = 0, firstNew = null;

    function writeStatus(msg) { if (statusEl) statusEl.textContent = msg; }

    function render(state, info) {
      if (!bar) return;
      var v = view(state);
      bar.setAttribute('aria-busy', v.busy ? 'true' : 'false');
      if (grid) grid.setAttribute('aria-busy', v.busy ? 'true' : 'false');
      bar.classList.toggle('is-error', state === 'error');
      bar.classList.toggle('is-end', state === 'end');
      if (state === 'end') bar.removeAttribute('data-next');
      if (state === 'error') writeStatus('Weitere ' + noun + ' konnten nicht geladen werden.');
      if (state === 'end' && info && info.count) writeStatus('Alle ' + shown + ' ' + noun + ' geladen.');
      if (!btn) return;
      /* Verschwindet der Knopf unter dem Fokus, geht der Fokus auf die erste
         neue Karte — sonst landet die Tastatur wieder am Seitenanfang. */
      if (v.hidden && document.activeElement === btn && firstNew) {
        try { firstNew.focus({ preventScroll: true }); } catch (e) {}
      }
      btn.hidden = v.hidden;
      btn.disabled = v.disabled;
      btn.textContent = v.text;
    }

    function load(url, signal) {
      return fetchPage(url, opts.sectionId, signal).then(function (doc) {
        /* 200, aber weder Section- noch Vollseiten-Antwort enthielt die
           Ergebnisliste (leerer Body, Zwischenseite eines Proxys): das ist ein
           FEHLER, kein Ende. Vorher wurde daraus „0 Karten, keine Folgeseite"
           → Knopf weg, keine Meldung, die restlichen Seiten unerreichbar. */
        if (!doc || !doc.querySelector('#r24col-results')) { var e = new Error('Antwort ohne Ergebnisliste'); e.status = 0; throw e; }
        var cards = [].slice.call(doc.querySelectorAll('#r24col-grid > .r24col-card'));
        /* Suche: Trenner „Ähnliche Produkte“ (sections/r24-search-2026) steht vor dem ersten Karten-Index,
           der kein echter Treffer ist — er wandert mit, wenn die Liste ihn noch nicht hat. */
        var sep = doc.querySelector('#r24col-grid > .r24srch-sep'), at = -1;
        if (sep) { var nx = sep.nextElementSibling; at = nx ? cards.indexOf(nx) : cards.length; }
        var nb = doc.querySelector('[data-r24-morebar]');
        return { cards: cards, count: cards.length, sep: sep, sepAt: at, next: nb ? nb.getAttribute('data-next') : null };
      });
    }

    function apply(res, url) {
      if (!grid) return;
      /* Leiste zuerst auf den neuen Stand, DANN melden — sonst zaehlen Reiter
         und Treffer-Hinweis nach der letzten Seite noch „36+". Gleiche Regel
         wie im Kern: nur die unmittelbar folgende Seite ist gueltig. */
      if (res.next && pageOf(res.next) === pageOf(url) + 1) bar.setAttribute('data-next', res.next);
      else bar.removeAttribute('data-next');
      firstNew = null;
      /* Shopifys Suche liefert bei semantischen Ergebnissen Artikel teils auf zwei Seiten
         (30.09.2026: „Marly“ Seite 1 und 2). Bereits sichtbare Produkte nicht doppelt anhaengen;
         der Trenner behaelt seinen Platz vor der ersten verbliebenen Karte. */
      var have = {};
      try { [].slice.call(grid.querySelectorAll(':scope > .r24col-card a[href*="/products/"]')).forEach(function (a) { if (a.pathname) have[a.pathname] = 1; }); } catch (e) {}
      var sepCard = res.sepAt >= 0 ? res.cards[res.sepAt] || null : null, keep = [];
      res.cards.forEach(function (c) {
        var a = c.querySelector && c.querySelector('a[href*="/products/"]'), k = a && a.pathname ? a.pathname : '';
        if (k && have[k]) { if (c === sepCard) sepCard = 'next'; return; }
        if (sepCard === 'next') sepCard = c;
        if (k) have[k] = 1;
        keep.push(c);
      });
      if (res.sep && res.sepAt >= 0) res.sepAt = sepCard && sepCard !== 'next' ? keep.indexOf(sepCard) : keep.length;
      res.cards = keep; res.count = keep.length;
      var addSep = res.sep && res.sepAt >= 0 && !grid.querySelector(':scope > .r24srch-sep');
      res.cards.forEach(function (c, i) {
        if (addSep && i === res.sepAt) grid.appendChild(res.sep);
        /* Der Bild-Link ist tabindex=-1/aria-hidden (Titel-Link ist der
           Tabstopp) — der Fokus gehoert auf den ersten ERREICHBAREN Link. */
        if (i === 0) firstNew = c.querySelector('a[href]:not([tabindex="-1"])') || c.querySelector('a[href]');
        grid.appendChild(c);
      });
      if (addSep && res.sepAt >= res.cards.length) grid.appendChild(res.sep);
      shown += res.count;
      bar.setAttribute('data-shown', String(shown));
      /* Suche mit eingeklappten aehnlichen Produkten: total = echte Treffer, angehaengt werden auch (verborgene)
         aehnliche Karten — die Anzeige bleibt darum hoechstens bei total (nie „290 von 248“). */
      var vis = total ? Math.min(shown, total) : shown;
      var st = bar.querySelector('[data-shown-txt]'); if (st) st.textContent = vis;
      var pr = bar.querySelector('[data-progress]');
      if (pr) pr.style.width = (total ? Math.min(100, shown / total * 100) : 100) + '%';
      /* EINE Meldung je Batch, hoeflich — kein Dauerfeuer fuer Vorleser. */
      writeStatus(res.count + ' weitere ' + noun + ' geladen – ' + vis + ' von ' + total + '.');
      if (opts.onAppend) opts.onAppend(res.cards);
    }

    function observe() {
      if (io) { io.disconnect(); io = null; }
      if (!bar || !('IntersectionObserver' in W)) return;
      io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          /* Regel 3: nur nach eigenem Scrollen. Bei kurzen Listen liegt die
             Leiste schon beim Oeffnen im Bild — das allein ist kein Wunsch
             nach mehr. Der Observer meldet nur Zustandswechsel: bleibt die
             Leiste nach dem Anhaengen im Bild, folgt KEIN weiterer Abruf. */
          if (entries[i].isIntersecting && (W.pageYOffset || 0) > 0) { pager.auto(); break; }
        }
      }, { rootMargin: opts.rootMargin || '0px 0px 400px 0px' });
      io.observe(bar);
    }

    function bind() {
      bar = root.querySelector('[data-r24-morebar]');
      grid = root.querySelector('#r24col-grid');
      btn = bar ? bar.querySelector('[data-r24-loadmore]') : null;
      statusEl = bar ? bar.querySelector('[data-r24-more-status]') : null;
      total = bar ? parseInt(bar.getAttribute('data-total'), 10) || 0 : 0;
      shown = bar ? parseInt(bar.getAttribute('data-shown'), 10) || 0 : 0;
      firstNew = null;
      var nextUrl = bar ? bar.getAttribute('data-next') : null;
      if (!pager) pager = core({ next: nextUrl, autoMax: opts.autoMax, load: load, apply: apply, onState: render });
      else pager.reset(nextUrl);
      observe();
    }

    bind();

    return {
      /** Klick auf „Mehr laden“: genau EIN Batch. */
      more: function () { return pager.more(); },
      /** Vor einem Filter-/Sortier-/Zurueck-Wechsel. */
      stop: function () { if (io) { io.disconnect(); io = null; } pager.stop(); },
      /** Nach dem Austausch der Ergebnisliste: neue Leiste, wieder ab Seite 2. */
      rebind: bind,
      /** Nur fuer Tests und Diagnose. */
      core: function () { return pager; }
    };
  }

  W.R24Pager = { core: core, view: view, mount: mount, fetchPage: fetchPage, pageOf: pageOf, AUTO_MAX: AUTO_MAX };

  /* Warteschlange der Sections, die vor dieser Datei ausgefuehrt wurden. */
  /* Ein Fehler in EINER Section-Initialisierung darf die anderen nicht
     aufhalten — aber auch nicht spurlos verschwinden (vorher: leeres catch,
     eine kaputte Suche/Kategorie hinterliess keine einzige Konsolenzeile). */
  var q = W.R24PagerQ;
  if (q && q.length) { for (var i = 0; i < q.length; i++) { try { q[i](W.R24Pager); } catch (e) { warn('Initialisierung einer Section', e); } } }
  W.R24PagerQ = { push: function (fn) { try { fn(W.R24Pager); } catch (e) { warn('Initialisierung einer Section', e); } } };
})(typeof window !== 'undefined' ? window : this);
